import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/controller';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import { Box, Stack, SxProps, Theme, useTheme } from '@mui/material';
import {
  useInternetStatus,
  useOneSignal,
  useRouterProtector,
  useSelectInitialCity,
  useStateObserver,
} from '@/logic/hooks';

import { EnvironmentInfo } from './environment-info';

import type { NextPage } from 'next';
import { Props } from '../../@types';
import dynamic from 'next/dynamic';
import shallow from 'zustand/shallow';
import { useWalletBalance } from '@/features/wallet/hooks/use-wallet-balance';
import { useCities } from '@/logic/state';
import { useGetCities } from '@/services';
import { useDataLayer } from '@/logic/hooks/use-data-layer';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';

const Umbrella = dynamic(
  () => import('./umbrella').then(component => component.Umbrella),

  { ssr: false }
);

// TODO: place useGetCities in proper place and hide all website layout until cities list is available

export const Layout: NextPage<Props> = ({ children }) => {
  const theme = useTheme();
  const setCities = useCities(s => s.setCities, shallow);
  useInternetStatus();
  useRouterProtector();
  useStateObserver();
  useSelectInitialCity();
  useOneSignal();
  // useAdBlockDetector();
  useWalletBalance();
  useDataLayer();

  useGetCities(
    {},
    {
      onSuccess: data =>
        setCities({
          citiesList: data.city,
        }),
    }
  );

  const sx: Partial<SxProps<Theme>> = {
    backgroundColor: theme.palette.layout.backgroundColor,
  };

  return (
    <Box sx={sx}>
      <Stack
        sx={{
          minHeight: '100vh',
        }}
      >
        <EnvironmentInfo />
        <Navbar />
        <Box id='layout' component='main'>
          {children}
        </Box>
        <Footer />
      </Stack>
      <Umbrella />
    </Box>
  );
};
